import React from 'react'
import Navbar from './Head/Navbar'
import Footer from '../components/footer/Footer'

export default function Layout({children}) {
    return (
        <div>
            <Navbar />
            {children}
            <Footer/>
        </div>
    )
}
